import { showSuccessAlert } from 'actions';
import {
  deleteTaskByJob,
  deleteTaskByJobFailure,
  deleteTaskByJobRequest,
  deleteTaskByJobSuccess,
  fetchActiveTasks,
  fetchActiveTasksFailure,
  fetchActiveTasksFulfill,
  fetchActiveTasksRequest,
  fetchActiveTasksSuccess,
  resetTaskByJob,
  resetTaskByJobFailure,
  resetTaskByJobSuccess,
} from 'actions/tasks';
import { apiClient as LitLingoClient } from 'client';
import { call, put, takeLatest } from 'redux-saga/effects';
import type { API, SagaReturn } from 'types';

function* fetchActiveTasksSaga(): SagaReturn {
  yield put(fetchActiveTasksRequest());

  const response = (yield call([LitLingoClient.resources.tasks.extras, 'getActiveTasks'], {
    params: {},
  })) as API.Response<API.Tasks.GetActiveTasks>;

  if (response.error != null) {
    yield put(fetchActiveTasksFailure(response.error));
  } else {
    yield put(fetchActiveTasksSuccess(response.data));
  }
  yield put(fetchActiveTasksFulfill());
}

function* deleteTaskByJobSaga(action: ReturnType<typeof deleteTaskByJob>): SagaReturn {
  const { jobId } = action.payload;
  yield put(deleteTaskByJobRequest());

  const response = (yield call([LitLingoClient.resources.tasks.extras, 'deleteByJob'], {
    urlParams: { jobId },
  })) as API.Response<API.Tasks.DeleteByJob>;

  if (response.error != null) {
    yield put(deleteTaskByJobFailure(response.error));
  } else {
    yield put(deleteTaskByJobSuccess());
    yield put(showSuccessAlert('Task was deleted successfully'));
  }
}

function* resetTaskByJobSaga(action: ReturnType<typeof resetTaskByJob>): SagaReturn {
  const { jobId } = action.payload;

  const response = (yield call([LitLingoClient.resources.tasks.extras, 'resetByJob'], {
    urlParams: { jobId },
  })) as API.Response<API.Tasks.ResetByJob>;

  if (response.error != null) {
    yield put(resetTaskByJobFailure(response.error));
  } else {
    yield put(resetTaskByJobSuccess());
    yield put(showSuccessAlert('Task status was updated to pending successfully'));
  }
}

function* tasksSaga(): SagaReturn {
  yield takeLatest(fetchActiveTasks.toString(), fetchActiveTasksSaga);
  yield takeLatest(deleteTaskByJob.toString(), deleteTaskByJobSaga);
  yield takeLatest(resetTaskByJob.toString(), resetTaskByJobSaga);
}

export default tasksSaga;
